<template>
  <div class="mit-maps-page mit-page">
      <v-container fluid>
      <v-row no-gutters>
        <v-col cols="12" class="d-flex">
          <v-card class="mit-info-card">
            <v-card-title>Building {{$route.params.buildingMitId}}</v-card-title>
            <v-card-subtitle class="caption">CSAIL Maps</v-card-subtitle>
            <v-divider></v-divider>

            <v-card-text>
               <MitSpacesMap :buildingMitId="$route.params.buildingMitId" :editMode="false"/>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
    import AnalyticsTracker from '../services/MitAnalyticsTracker.js';
    import MitSpacesMap from '../components/MitSpacesMap.vue';

  export default {
    name: 'MitMapsPage',
    components: {
        MitSpacesMap
    },
    data: function() {
      return {
      }
  },
    created(){

    },
    mounted() {
        // Analytics Metric 2: Map Visit
        AnalyticsTracker.track('map_interaction', 'view_map', {
        building_id: this.$route.params.buildingMitId
        });
    },
    methods : {

    }
  }
</script>

<style lang="scss" scoped>
  .mit-info-card {
    width:100%;
    height:100%;
  }
</style>
